module.exports = __webpack_public_path__ + "static/img/aboutPagePic.2258bac.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/aboutPagePic.png
// module id = jWmf
// module chunks = 3